(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name documentManager.factory:DocumentManagerRequestFactory
     *
     * @description
     *
     */
    angular
        .module('documentManager')
        .factory('DocumentManagerRequestFactory', DocumentManagerRequestFactory);

    function DocumentManagerRequestFactory() {

        function AdminDocumentDownloadRequest() {
            this.title = null;
            this.summary = null;
            this.status = null;
            this.categoryCode = null;
            this.crewTypeCode = [];
            this.crewProfileId = null;
            this.downloadId = null;
            this.version = null;
            this.filePath = null;
            this.validUntilDate = null;
            this.concatanateDateTimeToFilePath = null;
            this.pageSize = null;
            this.startPosition = null;
        }

        function AdminDocumentUploadRequest() {
            this.title = null;
            this.summary = null;
            this.status = false;
            this.categoryCode = null;
            this.crewTypeCode = [];
            this.crewProfileId = null;
            this.downloadId = null;
            this.version = null;
            this.filePath = null;
            this.validUntilDate = null;
            this.concatanateDateTimeToFilePath = null;
        }

        function GetDocumentSearchRequest() {
            return new AdminDocumentDownloadRequest();
        }

        function GetDocumentUploadRequest() {
            return new AdminDocumentUploadRequest();
        }

        function GetEditOptions(){
            return {
                id:null,
                mode: null,
                masterList: null,
                selectedItem: null,
                submitCallBack: null,
                changeFieldsCallBack:null
            }
        }

        return {
            getDocumentSearchRequest: GetDocumentSearchRequest,
            getEditOptions: GetEditOptions,
            getDocumentUploadRequest: GetDocumentUploadRequest
        }
    }
})();
